import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../shared/api.service';

@Component({
  selector: 'vc-recovery',
  templateUrl: 'recovery.component.html',
  styleUrls: ['./recovery.component.less', './../shared/common.less'],
})

export class RecoveryComponent {
  loading: boolean;
  validEmail: boolean;
  displayRecoveryPopup: boolean = false;
  requestResult: boolean = true;
  mailInput: string = "";
  user: string;
  isError = false;
  isMobile = false;
  errorMessage: string;
  constructor(private router: Router, private apiService: ApiService) {
  }

  dismissError() {
    this.isError = false;
  }

  onUserInput(event) {
    this.mailInput = event.target.value;
    this.isValidEmail(this.mailInput);
  }


  isValidEmail(email: string): boolean {
    if (!email) {
      return false;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,10}$/;

    this.validEmail = emailRegex.test(email);
    return this.validEmail;
  }

  login() {
    this.loading = true;
    this.apiService.recoverEmail(this.mailInput).subscribe((res) => {
      this.loading = false;
      this.displayRecoveryPopup = true;
      this.requestResult = true;
    }, (err: any) => {
      this.loading = false;
      this.displayRecoveryPopup = true;
      this.requestResult = false;
    });
  }
}
